module.exports = __webpack_public_path__ + "img/enabled_selected.ba607349.svg";